import { Tabs } from "@finanedi.es/storybook"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { TFunction } from "i18next"
import { DropdownChangeParams } from "primereact/dropdown"
import { useTranslation } from "react-i18next"
import { ResumenImpuesto } from "./components/ResumenImpuesto"
import { DETALLE_IMPUESTOS_TABS } from "./constants/detalleImpuestosTabs"
import { MODELOS_IMPUESTOS } from "./constants/modelosImpuestos"
import { useDetalleImpuesto } from "./hooks/useDetalleImpuesto"
import "./tablestyle.module.css"

export interface HandleTabs {
  t: TFunction
  year: {
    selectedYear: string
  }
  handleYearSelection: (e: DropdownChangeParams) => void
  yearsOptionList: string[] | undefined
}

export const DetalleImpuestos = () => {
  const { t } = useTranslation()

  const {
    handleYearSelection,
    yearsOptionList,
    handleRangeDateSelection,
    selectedDateRange,
    selectedYear,
    model,
    setModel,
  } = useDetalleImpuesto()

  const handleTabs: HandleTabs = {
    t,
    year: {
      selectedYear,
    },
    handleYearSelection,
    yearsOptionList,
  }

  const tabSelectedIndex = MODELOS_IMPUESTOS()[model].tabIndex ?? 0
  return (
    <div
      className={`tw-bg-white ${
        (model === MODELO_IMPUESTO.MODELO_190 ||
          model === MODELO_IMPUESTO.MODELO_180 ||
          model === MODELO_IMPUESTO.MODELO_347) &&
        "tw-h-full"
      }`}
    >
      <div className='tw-text-2xl tw-font-medium tw-text-shadow-default tw-text-left tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-shadow-3xl tw-mb-1 tw-py-4 tw-px-4'>
        {t("taxSummary.title")}
      </div>
      <Tabs
        tabSelected={tabSelectedIndex}
        tabs={DETALLE_IMPUESTOS_TABS(handleTabs, setModel)?.map(
          (tabList) => tabList.tabTitle
        )}
        tabTitle={[]}
        tabsContainerTailwind='tw-flex tw-flex-row tw-items-center tw-border-0 tw-border-b tw-border-solid tw-border-gray-200 tw-shadow-3xl tw-mb-1 tw-px-2'
        tabsTailwind='tw-mx-3 tw-cursor-pointer tw-select-none tw-mr-8 tw-text-primary-50 tw-h-16 tw-flex tw-items-center tw-text-lg'
        tabsActiveTailwind='tw-mx-3 tw-cursor-pointer tw-select-none tw-mr-8 tw-text-primary tw-font-medium tw-border-0 tw-border-b-4 tw-border-solid tw-border-primary tw-h-16	tw-flex tw-items-center tw-text-lg'
        tabChild={DETALLE_IMPUESTOS_TABS(handleTabs, setModel)?.map(
          (tabList) => (
            <div key={`${tabList.model}`}>{tabList.tabBody}</div>
          )
        )}
      />
      {model !== MODELO_IMPUESTO.MODELO_190 &&
        model !== MODELO_IMPUESTO.MODELO_180 &&
        model !== MODELO_IMPUESTO.MODELO_347 && (
          <ResumenImpuesto
            selectedDateRange={selectedDateRange}
            selectedYear={selectedYear}
            handleRangeDateSelection={handleRangeDateSelection}
            detailModel={model}
          />
        )}
    </div>
  )
}
